export const styles = theme => ({
    boxAction: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(3)
    },
    title: {
        marginRight: theme.spacing(2)
    }
})